<template>
	<div class="container">
		<div class="footer">
	    	<p>
	    		<span>主办单位:中国专利信息中心</span>
	    		<span>技术支持:北京宇久科技有限公司</span>
	    		<span>版权所有</span>
	    		<span>未经许可</span>
	    		<span>不得转载</span>
	    	</p>
	    	<p>
	    		<span>联系我们</span>
	    		<span>地址:北京市海淀区高梁桥斜街11号院中国专利大厦</span>
	    		<span>邮编:100044</span>
	    		<span>电话:010 8212 0600</span>
	    	</p>
	    	<p>
          <a :href="'https://beian.miit.gov.cn'"  style=" text-decoration:none; cursor:pointer;color: #9F9F9F;" target="_blank" >京ICP备16064517号-1</a>
	    		<!-- <span onclick="window.open('https://beian.miit.gov.cn/')" style=" text-decoration:none; cursor:pointer;">京ICP备16064517号-1</span> -->
	    	</p>
	    </div>

	</div>

</template>

<script>
	export default {
		name: 'indexfooter',
		data() {
			return {

			};
		}
	}
</script>

<style scoped>
	.footer{
		text-align: center;
		padding: 20px;
		line-height: 25px;
		font-size: 14px;
		color: #9F9F9F;
	}
	.footer span{
		padding: 0px 5px;
	}
</style>



// WEBPACK FOOTER //
// src/view/layout/footer/index.vue